(function() { window.GUID_ee3ed56b_f5fe_4e0f_874c_af693dd9485d = { getGuid: function() { return "ee3ed56b-f5fe-4e0f-874c-af693dd9485d"; } }; })();
//namespace CS.Controls {
//    export class SportEvent extends ControlBase {
//        private $control: JQuery;
//        private controlId: string;
//        public get ControlId(): string {
//            return this.controlId;
//        }
//        public get $Control(): JQuery {
//            return this.$control;
//        }
//        protected OnControlInstantiation(params: any[]) {
//            this.controlId = params[0];
//            this.$control = $('#' + params[0]);//contient le Id
//        }
//        public OnDispose() {
//            this.$control.off('click.' + this.UniqueNamespace);
//            this.$control.remove();
//        }
//        public OnBindEvents() {
//            let me = this;
//            me.$Control.on('click.' + this.UniqueNamespace, 'tr', function (e) {
//                let $this = $(this);
//                if ($this.hasClass('see-more-rows')) {
//                    me.Trigger<SportEvent.ISeeMoreClickedEventArgs>(SportEvent.EventNames.SeeMoreClicked, { jqueryEventObject: e, data: { takemax: $this.data('takemax') } });
//                    //me.RaiseEvent(SportEventEvents.SeeMoreClicked, e, $this.data('takemax'));
//                }
//                else {
//                    let href = $(this).data('href');
//                    if (href != null) {
//                        CS.Nav.Go(href);
//                    }
//                }
//            });
//        }
//        OnControlInstantiated() {
//        }
//    }
//    export namespace SportEvent {
//        export class Events {
//            public static SeeMoreClicked(param: IEvent<SportEvent, ISeeMoreClickedEventArgs>) {
//                RegisterEvent(SportEvent, EventNames.SeeMoreClicked, param);
//            }
//        }
//        export class EventNames {
//            public static SeeMoreClicked = "see-more-clicked";
//        }
//        export interface ISeeMoreClickedEventArgs {
//            takemax: number;
//        }
//    }
//}

//# sourceMappingURL=sportevent.js.map
